import React from "react";
import Button from "../ui/Button";
import Input from "../ui/Input";
import AiDisclaimer from "./AiDisclaimer";

const QUICK_HINTS = [
  "How do I improve photo labels?",
  "What does code upgrade mean?",
  "Why are exports disabled on Free?",
];

function nowTime() {
  return new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
}

function assistantReply(text) {
  const q = String(text || "").toLowerCase();
  if (q.includes("label")) {
    return "Use clear room photos plus close-ups for damage. Re-analyze individual photos after updating room/damage description fields.";
  }
  if (q.includes("code") || q.includes("zip")) {
    return "Code upgrades use the property ZIP to prioritize government-code signals and add compliance review line items.";
  }
  if (q.includes("free") || q.includes("export")) {
    return "Free plan supports core build, mitigation, and contents workflows. Exports, internet replacement pricing, and property code upgrades require Starter or Pro.";
  }
  if (q.includes("qty") || q.includes("quantity")) {
    return "If quantity is blank, check photo labels and rerun processing. The engine fills quantity from metadata when signals are available.";
  }
  return "I can help with build flow, mitigation, contents corner, review flow, labels, code upgrades, and billing tiers. Try asking one of the quick questions.";
}

export default function AiAssistantChat() {
  const [open, setOpen] = React.useState(false);
  const [input, setInput] = React.useState("");
  const [messages, setMessages] = React.useState([
    {
      id: "m0",
      role: "assistant",
      text: "Hi, I’m your assistant. Ask me about labels, suggestions, code upgrades, or billing.",
      time: nowTime(),
    },
  ]);

  const submit = (prompt) => {
    const text = String(prompt || input || "").trim();
    if (!text) return;
    const userMsg = { id: `u-${Date.now()}`, role: "user", text, time: nowTime() };
    const botMsg = { id: `a-${Date.now()}`, role: "assistant", text: assistantReply(text), time: nowTime() };
    setMessages((prev) => [...prev, userMsg, botMsg]);
    setInput("");
  };

  return (
    <div className="fixed bottom-4 right-4 z-50">
      {open ? (
        <div className="w-[360px] max-w-[92vw] overflow-hidden rounded-2xl border border-zinc-300 bg-white shadow-2xl">
          <div className="flex items-center justify-between border-b border-zinc-200 bg-zinc-900 px-3 py-2 text-white">
            <p className="text-sm font-semibold">AI Assistant</p>
            <button
              type="button"
              className="rounded px-2 py-1 text-xs hover:bg-white/15"
              onClick={() => setOpen(false)}
            >
              Close
            </button>
          </div>
          <div className="max-h-[320px] space-y-2 overflow-y-auto bg-zinc-50 p-3">
            <AiDisclaimer
              title="Assistant Limitation"
              detail="This assistant can provide guidance but may be inaccurate. Do not treat responses as legal, safety, insurance, or code compliance advice."
            />
            {messages.map((m) => (
              <div key={m.id} className={`rounded-lg p-2 text-sm ${m.role === "user" ? "ml-8 bg-red-50 text-zinc-900" : "mr-8 bg-white text-zinc-800 border border-zinc-200"}`}>
                <p>{m.text}</p>
                <p className="mt-1 text-[10px] uppercase tracking-wide text-zinc-400">{m.time}</p>
              </div>
            ))}
          </div>
          <div className="space-y-2 border-t border-zinc-200 p-3">
            <div className="flex flex-wrap gap-1">
              {QUICK_HINTS.map((q) => (
                <button
                  key={q}
                  type="button"
                  className="rounded-full border border-zinc-300 bg-white px-2 py-1 text-[11px] text-zinc-700 hover:bg-zinc-100"
                  onClick={() => submit(q)}
                >
                  {q}
                </button>
              ))}
            </div>
            <div className="flex gap-2">
              <Input
                value={input}
                placeholder="Ask a question..."
                onChange={(e) => setInput(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") submit();
                }}
              />
              <Button onClick={() => submit()} size="sm">
                Send
              </Button>
            </div>
          </div>
        </div>
      ) : (
        <Button onClick={() => setOpen(true)}>AI Assistant</Button>
      )}
    </div>
  );
}
